import Vue from 'vue'
import VueRouter from 'vue-router'
import List from '../views/list/list.vue'
import {getItem} from '../utils/storage'
import {error} from '@/utils/message'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/home',
  //   name: 'home2',
  //   component: Index
  // },
  {
    path: '/',
    name: 'home',
    component: List
  },
  {
    path: '/icp',
    name: 'icp',
    component: () => import('../views/icp.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('../views/reset/reset.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail/detail.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order/order.vue')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('../views/pay/pay.vue')
  },
  {
    path: '/payline',
    name: 'payline',
    component: () => import('../views/payline/payline.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/user/userinfo/userinfo.vue')
  },
  {
    path: '/user/order',
    name: 'user-order',
    component: () => import('../views/user/order/order.vue')
  },
  {
    path: '/user/address',
    name: 'user-address',
    component: () => import('../views/user/address/address.vue')
  },
  {
    path: '/user/safe',
    name: 'user-safe',
    component: () => import('../views/user/safe/safe.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/cart/cart.vue')
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('../views/article/article.vue')
  },
  {
    path: '/article/index',
    name: 'article-index',
    component: () => import('../views/article/index/index.vue')
  },
  {
    path: '/article/list',
    name: 'article-list',
    component: () => import('../views/article/list/list.vue')
  },
  {
    path: '/article/detail',
    name: 'article-detail',
    component: () => import('../views/article/detail/detail.vue')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('../views/notice/index/index.vue')
  },
  {
    path: '/notice/detail',
    name: 'notice-detail',
    component: () => import('../views/notice/detail/detail.vue')
  },
]



const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next)=>{
  let user = getItem('userinfo')
  if (!user) {
    let inRouterList = [
        'user-order',
        'user-address',
        'user-safe',
        'cart',
        'user-order',
        'user',
        'pay'
    ]
    let routerName = to.name
    let ret = inRouterList.find( (item) => {
        return item === routerName
    })
    if (ret) {
      error('您还没有登录，请先登录')
      next('/login')
    } else {
      next()
    }
  }else{
    next()
  }
})

export default router
